/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, Dispatch, SetStateAction } from 'react'

// 定义上下文的类型
interface UploadContextType {
  modalLoading: boolean
  setModalLoading: Dispatch<SetStateAction<boolean>>
}

// 创建一个默认值，注意必须符合 UploadContextType 类型
const defaultContextValue: UploadContextType = {
  modalLoading: false,
  setModalLoading: () => {}, // 默认的setModalLoading是一个空函数，初始化时不做实际操作
}

// 创建上下文
const uploadContext = createContext<UploadContextType>(defaultContextValue)
export default uploadContext
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, Dispatch, SetStateAction } from 'react'

// 定义上下文的类型
interface UploadContextType {
  modalLoading: boolean
  setModalLoading: Dispatch<SetStateAction<boolean>>
}

// 创建一个默认值，注意必须符合 UploadContextType 类型
const defaultContextValue: UploadContextType = {
  modalLoading: false,
  setModalLoading: () => {}, // 默认的setModalLoading是一个空函数，初始化时不做实际操作
}

// 创建上下文
const uploadContext = createContext<UploadContextType>(defaultContextValue)
export default uploadContext
